<p-toast position="bottom-center" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="p-text-center">
        <h3>{{message.summary}}</h3>
        <div *ngIf="message.detail" [innerHTML]="message.detail"></div>
      </div>
      <div class="p-col-6" *ngIf="message.data?.url">
        <ng-container *ngIf="isInternalUrl(message.data.url); then internalRouting else externalRouting"></ng-container>
        <ng-template #internalRouting>
          <button mat-raised-button [routerLink]="(message.data.url)" color="sims-dark" class="mt-2">{{ 'goTo' | translate }}</button>
        </ng-template>
        <ng-template #externalRouting>
          <a mat-raised-button [href]="message.data.url" target="_blank" color="sims-dark" class="mt-2">{{ 'goTo' | translate }}</a>
        </ng-template>
      </div>
    </div>
  </ng-template>
</p-toast>